import { render } from "./CompanyLayout.vue?vue&type=template&id=dcb57b38&scoped=true"
import script from "./CompanyLayout.vue?vue&type=script&lang=js"
export * from "./CompanyLayout.vue?vue&type=script&lang=js"

import "./CompanyLayout.vue?vue&type=style&index=0&id=dcb57b38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcb57b38"]])

export default __exports__